<template>
  <layout
    title="Validator"
    >
    
    Test Validator

    <w-divider class="my2" />

    <w-form>

    <w-input label="required" :validators="[validators.required]"></w-input>
    <w-input label="numeric" :validators="[validators.numeric]"></w-input>
    <w-input label="date" :validators="[validators.date]"></w-input>
    <w-input label="alpha" :validators="[validators.alpha]"></w-input>
    <w-input label="alphanumeric" :validators="[validators.alphanum]"></w-input>
    </w-form>
    
  </layout>
</template>

<script>
import ZResource from '@/Modules/z-resource'
export default {
  extends: ZResource,
}
</script>
